<template>
  <loading-wrapper
    :loading="loading"
    class="section"
  >
    <div
      v-if="selectedDepartment"
      class="container center max-width-mobile"
    >
      <div class="tipping-share-card">
        <div
          v-if="selectedDepartment.photoUrl"
          class="tipping-share-card--image tipping-share-card--image__department"
          :style="{ 'background-image': `url(${selectedDepartment.photoUrl})` }"
        />

        <router-link
          v-slot="{ href }"
          :to="{ name: 'departmentTipping' }"
        >
          <div class="tipping-share-card--content">
            <h2 class="title title--2">{{ selectedDepartment.name }}</h2>

            <vue-qrcode
              class="image tipping-share-card--qr-code"
              :value="`${baseUrl}${href}`"
              :width="500"
              :margin="0"
            />

            <div class="buttons justify-center">
              <a
                target="_blank"
                :href="href"
                class="button button--small button--primary button--auto-width"
              >
                <span class="icon far fa-external-link" />
                View Page
              </a>

              <button
                v-copy-to-clipboard="{ value: `${baseUrl}${href}` }"
                type="button"
                class="button button--small button--secondary button--auto-width"
              >
                <span class="icon far fa-copy" />
                Copy Link
              </button>
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </loading-wrapper>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'DepartmentSharePage',

    metaInfo() {
      return {
        title: this.selectedDepartment?.name
      };
    },

    data: () => ({
      loading: true
    }),

    computed: {
      ...mapGetters('hotels', ['selectedDepartment']),

      baseUrl() {
        return window.location.origin;
      }
    },

    created() {
      this.fetchDepartment();
    },

    methods: {
      async fetchDepartment() {
        await this.$store.dispatch('hotels/fetchDepartment', this.$route.params.departmentId);
        this.loading = false;
      }
    }
  };
</script>
